import { Link, useNavigate } from 'react-router-dom';
import DataTable from '../../../../components/table/DataTable';
import http from '../../../../api/axios';
import { useState, useEffect } from 'react';
import { apiUrl } from '../../../../api/apiUrl';
import { useCurrentCompany } from '../../../../hooks/useCompany';
import Button from '../../../../components/button/Button';
import { toast } from 'react-toastify';
import { paths } from '../../../RouterContainer';
import { columns } from '../../../../components/columns/Company/UserTeamsColumns';
import { Team } from '../../../../types/Team';
import { useTranslation } from '../../../../context/translationContext';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useBreadcrumbs } from '../../../../hooks/useBreadcrumbs';

/**
 * Page component represents Teams overview for current user
 */
export const UserTeamsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const [teams, setTeams] = useState<Team[] | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_TEAMS}`,
        name: 'navigation.my-teams',
      },
    ]);
  }, []);

  /**
   * Loads users teams
   */
  const fetchTeams = async () => {
    const response = await http.apiGet({
      url: apiUrl.TEAM_GET_USERS_TEAMS,
    });
    setTeams(response?.data);
  };

  /**
   * Refetch data when company changes.
   */
  useEffect(() => {
    fetchTeams();
  }, [company]);

  /**
   * Redirects to team edit
   * @param id team id
   */
  const onEditItem = async (id: string | number) => {
    if (id === null) return;
    navigate(`/${paths.MY_TEAMS}/edit/${id}`);
  };

  /**
   * Removes team. Uses delete API.
   * @param id team id
   */
  const onRemoveItem = async (id: string | number) => {
    if (id === null) return;
    const response = await http.apiDelete({ url: `${apiUrl.TEAM_DELETE}?id=${id}` });
    if (response?.status === 204) {
      toast.success('Success!');
      fetchTeams();
    }
  };

  return (
    <>
      <div className="flex justify-between">
        <h1 className="text-3xl font-bold">{t('page.team.headline-my-list')}</h1>
        <Link to={`/${paths.MY_TEAMS}/create`}>
          <Button
            title={t('general.create-new')}
            color="green"
            icon={<PlusIcon className="w-4 h-4 mr-2" />}
          />
        </Link>
      </div>

      <p>Přehled všech teamů přihlášeného uživatele.</p>

      <DataTable
        data={teams}
        columns={columns}
        handleEdit={onEditItem}
        handleRemove={onRemoveItem}
      />
    </>
  );
};
